import { Component } from '@angular/core';

@Component({
	selector: 'app-alert-bank-label',
	templateUrl: './alert-bank-label.component.html',
	styleUrls: ['./alert-bank-label.component.scss'],
})
export class AlertBankLabelComponent {}
